import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import useI18nTl from '@/hooks/useI18nTl'
import { upsertEvseProfile } from '@/api/evses'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import EvseProflieSchedule from './EvseProflieSchedule.vue'
export type OperationType = 'create' | 'edit'
import FormRulesFactory from '@/common/formRules'
import InputWithUnitNumber from '@/components/InputWithUnitNumber.vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseProflieUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isView: {
    type: Boolean,
    required: false,
  },
  evseId: {
    type: String,
    required: false,
  },
  profile: {
    type: Object,
    required: false,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const evseProfileFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['profile.chargingProfilePurpose', 'profile.chargingProfileKind'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['profile.stackLevel', 'cno'],
    'inputEmpty',
    'inputInvalid',
  ),
})
const { chargingProfilePurposes, chargingProfileKinds, recurrencyKinds } = useProtocolEnums()
const { t } = useI18nTl('Evses')
const profileSchedule = ref()





const createRawFormData = () => ({
  profile: {
    chargingSchedule: {
      chargingRateUnit: '',
      chargingSchedulePeriod: [],
      duration: null,
      minChargingRate: 0,
      startSchedule: '',
      minChargingRateInfo: '',
    },
  },
})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
// const { createLetterStartRule } = useFormRules()
// const rules = {
//   name: [...createLetterStartRule()],
// }

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const updateSchedule = (val: any) => {
  // console.log('接收到的更新数据1:', val);
  // console.log('接收到的更新数据2:', val.value);
  formData.value.profile.chargingSchedule = val
}

watch(showDialog, async (val) => {
  console.log('showDialog', val)
  console.log('props.isView', props.isView)
  if (props.isView) {
    formData.value = { ...props.profile }
  } else {
    formData.value = createRawFormData()
  }
  // if (val) {
  //   formData.value.profile.chargingSchedule = {}
  //   console.log('formData', formData.value)
  // }
})
const handleOpeenCardDialog = () => {
  nextTick(() => {
    // 清空校验
    profileSchedule.value.clearValidate()
    formCom.value.clearValidate()
  })
}
const submit = async () => {
  try {
    if (profileSchedule.value) {
      profileSchedule.value.validate()
    }
    await formCom.value.validate()
    isSubmitting.value = true

    formData.value.evseId = props.evseId
    formData.value.profile.chargingSchedule = profileSchedule.value.scheduleRecord
    console.log('--->formData.value: ', formData.value)

    await upsertEvseProfile(formData.value)
    ElMessage.success(t(`Base.opSuccess`))
    emit('submitted')

    showDialog.value = false
  } catch (error) {
    console.error(error)
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: _unref(t)('Evses.createProfile'),
    "append-to-body": true,
    onOpen: handleOpeenCardDialog,
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: evseProfileFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.chargingProfilePurpose'),
                    prop: "profile.chargingProfilePurpose",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.profile.chargingProfilePurpose,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.profile.chargingProfilePurpose) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chargingProfilePurposes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.chargingProfileKind'),
                    prop: "profile.chargingProfileKind",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.profile.chargingProfileKind,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.profile.chargingProfileKind) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chargingProfileKinds), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.recurrencyKind'),
                    prop: "profile.recurrencyKind"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.profile.recurrencyKind,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.profile.recurrencyKind) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recurrencyKinds), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.stackLevel'),
                    prop: "profile.stackLevel",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnitNumber, {
                        modelValue: formData.value.profile.stackLevel,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.profile.stackLevel) = $event)),
                        units: [{ label: 'L', value: '' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.cno'),
                    prop: "cno",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.cno,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.cno) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Order.orderID'),
                    prop: "profile.transactionId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.profile.transactionId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.profile.transactionId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.beginTime'),
                    prop: "profile.validFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.profile.validFrom,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.profile.validFrom) = $event)),
                        type: "date",
                        placeholder: _ctx.$t('Base.beginTime'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.endTime'),
                    prop: "profile.validTo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.profile.validTo,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.profile.validTo) = $event)),
                        type: "date",
                        placeholder: _ctx.$t('Base.endTime'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Evses.chargingSchedule')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(EvseProflieSchedule, {
                    ref_key: "profileSchedule",
                    ref: profileSchedule,
                    schedule: formData.value.profile.chargingSchedule,
                    "onUpdate:schedule": updateSchedule
                  }, null, 8, ["schedule"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})